import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Select, message } from 'antd';
import { Colors } from '../../helpers/Colors';
import DynamicTable from '../TableComponents/DynamicTable';
import { PlusOutlined } from '@ant-design/icons';
import { AddLocomotiveNotes, createLeaseLocomotive, getAllCustomerLocomotive, getAllLocomotiveLease, getAllNotes } from '../../Services/LocomotiveServices';
import moment from 'moment';
import DatePicker from 'react-date-picker';
import { showText } from '../../helpers/textValidation';
import { formatCurrency } from '../../helpers/currencyFormatter';
const LocomotiveLeaseModal = ({ open, close, data }) => {
    const [form] = Form.useForm()
    const [newLease, setNewLease] = useState(false)
    const [TableData, setTableData] = useState([])
    const [StartCheck, setStartCheck] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [Type, setType] = useState([
        {
            label: "W/ Maintenance",
            value: "W/ Maintenance"
        },
        {
            label: "Full Service",
            value: "Full Service"
        },
        {
            label: "Net",
            value: "Net"
        }
    ])
    const [customerList, setCustomerList] = useState([])
    const [EscalationType, setEscalationType] = useState([
        {
            label: "Fixed",
            value: "Fixed"
        },
        {
            label: "PPI",
            value: "PPI"
        },
        {
            label: "AAR (ALL-LF)",
            value: "AAR (ALL-LF)"
        },
        {
            label: "CPI",
            value: "CPI"
        }
    ])
    const [Evergreen, setEvergreen] = useState([

        {
            label: "Yes",
            value: "yes"
        },
        {
            label: "No",
            value: "No"
        }
    ])
    const formFields = [
        {
            name: "Customer",
            require: true,
            type: "Dropdown",
            key: "customer"

        },
        {
            name: "Start Date",
            require: true,
            type: "Date",
            key: "startDate"
        },
        {
            name: "End Date",
            require: true,
            type: "Date",
            key: "endDate"

        },

        {
            name: "Type",
            require: true,
            type: 'Dropdown',
            key: "type"
        },
        {
            name: "Esc Type",
            require: true,
            type: 'Dropdown',
            key: "EstType"
        },
        {
            name: "Evergreen",
            require: true,
            type: 'Dropdown',
            key: "evergreen"

        },
        {
            name: "Max Fix %",
            require: false,
            type: 'Number',
            key: "maxfix"

        },
        {
            name: "Monthly Amount",
            require: true,
            type: 'Number',
            key: "monthly_amt"
        }
    ]
    let table = {
        header: [
            "ID",
            "Customer",
            "Start",
            "End",
            "Term",
            "Type",
            "Escalation",
            "Monthly Amt"

        ],
        rows: TableData.map(item => [
            item?.id,
            `${item?.CustMaster?.id} / ${item?.CustMaster?.CustName}`,
            moment(item?.ContractStartDate).format('MM-DD-YYYY ') || "N/A",
            moment(item?.ContractEndDate).format('MM-DD-YYYY ') || "N/A",
            item?.Term,
            item?.AgreementType,
            item?.EscalationFixMax ? `${item?.EscalationType} - ${item?.EscalationFixMax}%` : item?.EscalationType,
            item?.MonthlyAmt ? formatCurrency(item?.MonthlyAmt, 'USD') : "N/A"
        ]
        )
    }
    const getAllLease = async () => {
        const result = await getAllLocomotiveLease(data?.id)
        if (result.httpStatus === 200) {
            setTableData(result.data)
        }
    }
    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

    const HandleSubmit = async (values) => {
        if (isSubmitting) {
            return;
        }

        // Set isSubmitting to true to indicate the start of form submission
        setIsSubmitting(true);

        try {
            let dataobj = {
                ContractStartDate: moment(values.startDate).format('MM-DD-YYYY'),
                ContractEndDate: moment(values.endDate).format('MM-DD-YYYY'),
                EscalationFixMax: Number(values.maxfix),
                AutoRenew: values.evergreen ? values.evergreen.toUpperCase() : null,
                MonthlyAmt: Number(values.monthly_amt),
                EscalationType: values.EstType,
                AgreementType: values.type,
                CustID: Number(values?.customer)
            }
            const result = await createLeaseLocomotive(data?.id, dataobj);

            if (result?.httpStatus === 200) {
                message.success('Contract created successfully!');
                getAllLease()
                form.resetFields()
                setNewLease(false)
            }
        } finally {
            // Set isSubmitting back to false after API call is complete
            setIsSubmitting(false);
        }


    }
    const getAllCustomer = async () => {
        const result = await getAllCustomerLocomotive()
        if (result?.httpStatus === 200) {
            let custList = result.data.map((item, index) => {
                return {
                    label: `${item?.id} / ${item?.CustName}`,
                    value: item?.id
                }
            })
            setCustomerList(custList)
        }

    }

    useEffect(() => {
        setNewLease(false)


    }, [])
    useEffect(() => {
        setStartCheck(false)
        if (open) {
            getAllLease()
            getAllCustomer()
        }
    }, [open])

    return (
        <>
            <Modal width={newLease ? 500 : 900} title={<p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "20px" }}>Lease Contracts </p>} open={open} onCancel={() => { setNewLease(false); close('lease') }} footer={null}>
                {/* Table----------> */}
                {
                    !newLease &&
                    <div style={{ marginBottom: "10px", display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                        {/* <Button onClick={() => { }} style={{ background: 'white', color: Colors.mainBlue }}> View Lease History</Button> */}
                        <p style={{ color: "black", fontWeight: "800", marginBottom: "0px", fontSize: "20px", marginTop: "-30px" }}>{data?.EquipUID}</p>

                        <Button onClick={() => { setNewLease(true) }} style={{ background: Colors.mainBlue, color: "white" }}><PlusOutlined /> Add Lease Contract</Button>
                    </div>
                }
                <div style={{}}>
                    {
                        newLease ?
                            <Form form={form} name='equipID' onFinish={HandleSubmit} style={{ width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                                    {formFields.map((item, index) => (
                                        item?.type !== 'Dropdown' & item?.type !== 'Date' ? <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                            <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>{item.name}</p>
                                            <Form.Item style={{ width: "100%", display: 'flex', justifyContent: "flex-end" }} name={item.key} rules={[{ required: item?.require, message: `${item.name} is required` }]}>
                                                <Input type={item.type} placeholder={`Enter ${item.name}.`} style={{
                                                    background: 'white',
                                                    border: `1px solid lightgray`,
                                                    fontSize: "13px",
                                                    width: "300px"
                                                }} />
                                            </Form.Item></div> : item?.type == 'Dropdown' ? <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                                <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>{item.name}</p>
                                                <Form.Item style={{ width: "100%", display: 'flex', justifyContent: "flex-end" }} name={item.key} rules={[{ required: item?.require, message: `${item.name} is required` }]}>
                                                    <Select style={{ width: "300px" }}
                                                        showSearch
                                                        placeholder={`Select ${item.name}.`}
                                                        optionFilterProp="children"
                                                        onChange={(value) => {   }}
                                                        onSearch={(value) => {   }}
                                                        filterOption={filterOption}
                                                        options={item?.name == 'Esc Type' ? EscalationType : item?.name == 'Evergreen' ? Evergreen : item?.name == 'Customer' ? customerList : Type}
                                                    />
                                                </Form.Item>
                                            </div> : <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                            <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>{item.name}</p>
                                            <Form.Item className='leaseDateCont' style={{}} name={item.key} rules={[{ required: item.require, message: `${item.name} is required` }]}>
                                                <DatePicker
                                                    required={true}
                                                    onChange={(value) => { if (item.name === 'Start Date') { setStartCheck(value) } }}
                                                    className="datePickerReact  bg-white react-date-picker"
                                                    style={{ background: 'white', borderRadius: '10px', width: "300px", }}
                                                    disabled={item.name === 'Start Date' ? false : StartCheck ? false : true}
                                                    message={'please fill this field'}
                                                    minDate={item.name == 'End Date' && StartCheck && StartCheck}
                                                    maxDate={new Date("02-29-9999")}
                                                />
                                            </Form.Item>

                                        </div>
                                    ))
                                    }
                                </div>
                                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                                    <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white" }}>
                                        Create
                                    </Button>
                                    <Button onClick={() => { setNewLease(false) }} style={{ background: 'white', color: Colors.mainBlue }}>
                                        View List
                                    </Button>
                                </div>
                            </Form>
                            :
                            <DynamicTable tableData={table} />
                    }
                </div>
            </Modal>
        </>
    );
};
export default LocomotiveLeaseModal;